import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from './creditIncentiveTypes'
import API from './creditIncentiveApis'

function* watchCreditIncentive(action) {
  try {
    const response = yield call(API.creditIncentive, action.payload)
    if (response.status === 201) {
      yield put({type: types.CREDIT_INCENTIVE_SUCCEEDED, payload: response.data})
      const message = action.payload.timeSlotIds?.length > 1 ? 'All selected bulk reward have been applied successfully.' : 'Reward Credited Successfully.'
      yield put({type: 'SHOW_MESSAGE', payload: {message, className: 'copy-screeners-snackbar'}})
      yield put({type: 'HIDE_MESSAGE'})
    }
  } catch (err) {
    yield put({type: types.CREDIT_INCENTIVE_FAILED, err})
    yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again',  className: 'error-snackbar'}})
    yield put({type: 'HIDE_MESSAGE'})
  }
}

export default function* () {
  yield takeLatest(types.CREDIT_INCENTIVE_REQUESTED, watchCreditIncentive)
}